<template>
    <b-form-group class="col-6">
      <v-select
        v-model="selected"
        label="title"
        :options="option"
        class="select-size-lg"
        :clearable="false"
      />
    </b-form-group>
</template>
<script>
import {
  BFormGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormGroup,
    vSelect,
  },
  data() {
    return {
      selected: { title: this.$store.state.user?.customerInfo?.domain || null },
      option: [],
      customerList:[]
    }
  },
  methods: {
    fetchCustomers() {

      if(this.isDeveloper){
        // Seçim odaklandığında istek gönderme
        this.$http.get('manage/customers')
          .then(response => {
            const { Customers } = response.data.data;
            this.customerList = Customers
            // Müşterileri istediğiniz gibi dönüştürebilirsiniz
            const transformedCustomers = Customers.map(order => ({
              title: order.domain, // title alanına uygun müşteri adını koyun
              value: order.id // Seçilen müşteri id'sini değer olarak atayın
            }));

            // Seçenekleri güncelle
            this.option = transformedCustomers;
          })
          .catch(() => {
            this.showErrorToast();
          });
      }else{
            this.customerList = this.$store.state.user.customers
            const transformedCustomers = this.$store.state.user.customers.map(order => ({
              title: order.domain, // title alanına uygun müşteri adını koyun
              value: order.id // Seçilen müşteri id'sini değer olarak atayın
            }));            
            this.option = transformedCustomers;
      }
    },
    
    async handleSelect(customer) {
      const selectedCustomer = this.customerList.find(item => item.id == customer.value);

      // setCustomerAndFetchSettings'in bitmesini bekle
      await this.$store.dispatch('user/setCustomerAndFetchSettings', selectedCustomer);

      // Güncelleme tamamlandıktan sonra loading başlat
      this.$store.commit('appConfig/UPDATE_LOADING', false);
      this.$nextTick(() => {
        this.$store.commit('appConfig/UPDATE_LOADING', true);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${selectedCustomer.name} hesabına geçiş yapıldı`,
            icon: 'WindIcon',
            variant: 'success',
          },
        });
      });
    },

    async handleSelect2(customer) {
      const selectedCustomer = this.customerList.find(item => item.id == customer.value);
      
      // 1️⃣ Sunucuya yeni JWT için istekte bulun
      const response = await this.$http.post('/user/switch', {
        email: this.$store.state.user.userData.email,
        customer_id: selectedCustomer.id,
        user_type:this.$store.state.user.userData.type
      });

      this.$store.commit('appConfig/UPDATE_LOADING', false);

      if (response.data.success) {
        // 2️⃣ Yeni token ve userData ile store'u güncelle
        if(response.data.developer){
          await this.$store.dispatch('user/setCustomerAndFetchSettings', selectedCustomer);
        }else{
          this.$store.commit('user/SET_SWITCH_CUSTOMER', response.data);
        }

        this.$nextTick(() => {
          this.$store.commit('appConfig/UPDATE_LOADING', true);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message ?? `${selectedCustomer.name} hesabına geçiş yapıldı`,
              icon: 'WindIcon',
              variant: 'success',
            },
          });
        });
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: response.data.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    },

    showErrorToast() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error fetching Customers list',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  },
  watch: {
    selected(newValue) {
      // Seçim yapıldığında handleSelect fonksiyonunu çağır
      this.handleSelect2(newValue);
    }
  },
  created () {
    this.fetchCustomers();
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
